import React from 'react';
import { TTemplate } from '@/helpers/createTemplate';

const template = (): TTemplate => ({
  content: <></>,
});

export default template;
